import React, { Component } from 'react';
import _ from 'lodash';
import { authService } from '../../utils/auth-service';

const hasUserInfo = WrapperComponent => class HasUserInfo extends Component {
  render() {
    const profile = authService.getProfile();

    const userInfo = {
      name: 'Anony Mous',
      email: 'anon@anonymous.com',
    };

    if (profile && _.has(profile, 'app_metadata')) {
      const {
        app_metadata: {
          dyzio: {
            email,
            name,
            o_id: organisationId,
            role,
            u_id: userId,
            isUserSuperAdmin,
          },
        },
      } = profile;

      const isDyzioUser = _.endsWith(email, '@dyzio.co') || _.endsWith(email, '@gifta.co.uk');
      const userInfo = {
        email,
        name,
        organisationId,
        role,
        userId,
        isUserSuperAdmin,
        isDyzioUser,
      };


      return (
        <WrapperComponent
          {...this.props}
          userInfo={userInfo}
        />);
    }

    return <WrapperComponent {...this.props} userInfo={userInfo} />;
  }
};

export default hasUserInfo;



/** WEBPACK FOOTER **
 ** ./src/hocs/has-user-info/index.js
 **/